import React, { useEffect } from 'react';
import AboutHero from './AboutHero/AboutHero';
import Mission from './Mvv/Mvv';
import { Helmet } from 'react-helmet';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Yeskondo Media Pvt Ltd",
    "url": "https://www.yeskondomedia.com/about",
    "logo": "https://www.yeskondomedia.com/logo.png",
    "description": "Yeskondo Media is recognized as the best marketing company in Pune, offering 360-degree digital marketing, web development, OOH advertising, and SEO services.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Deccan",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "postalCode": "411004",
      "addressCountry": "IN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-9922966739",
      "contactType": "customer service",
      "areaServed": "IN",
      "availableLanguage": ["English", "Hindi", "Marathi"]
    },
    "sameAs": [
      "https://www.facebook.com/yeskondomedia",
      "https://www.instagram.com/yeskondomedia",
      "https://www.linkedin.com/company/yeskondo-media-pvt-ltd/"
    ]
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.yeskondomedia.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "About Us",
        "item": "https://www.yeskondomedia.com/about"
      }
    ]
  };

  return (
    <>
      <Helmet>
        <title>About Us | Best Marketing Company in Pune | Yeskondo Media</title>
        <meta name="description" content="Learn about Yeskondo Media, the best marketing company in Pune. We deliver top-notch digital marketing, web development, OOH, and SEO services to grow your brand." />
        <meta name="keywords" content="Best marketing company in pune, digital marketing agency pune, top advertising agency pune, Yeskondo Media, web development pune, SEO services pune" />
        <link rel="canonical" href="https://www.yeskondomedia.com/about" />
        
        {/* Open Graph Tags */}
        <meta property="og:title" content="About Us | Best Marketing Company in Pune | Yeskondo Media" />
        <meta property="og:description" content="Discover why Yeskondo Media is trusted as the best marketing company in Pune for 360-degree digital transformation, branding, and OOH advertising." />
        <meta property="og:url" content="https://www.yeskondomedia.com/about" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.yeskondomedia.com/og-image.jpg" />
        
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Us | Best Marketing Company in Pune" />
        <meta name="twitter:description" content="Learn about Yeskondo Media, the best marketing company in Pune. We deliver top-notch digital marketing, web development, OOH, and SEO services." />
        <meta name="twitter:image" content="https://www.yeskondomedia.com/og-image.jpg" />

        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>
      
      <AboutHero />
      <Mission />
    </>
  );
};

export default About;

